import {
  getAudiosReuniao,
  getFotosReuniao,
  getVideosReuniao,
  postAudiosReuniao,
  postFotosReuniao,
  postVideosReuniao,
} from '../../../../../services/reuniao/ReuniaoService';
import {excluir} from "../../../../../services/documento/DocumentoService";

export const midiaInitialState = {
  0: {
    label: 'Fotos',
    files: [],
    fileExtension: ['JPG', 'PNG', 'JPEG'],
    text: () => {
      let fill = '';
      let arrExt = ['JPG', 'PNG', 'JPEG'];
      arrExt.forEach((item, index) => {
        let ext = '';
        if (index < arrExt.length - 2) {
          ext = ', ';
        } else if (index === arrExt.length - 2) {
          ext = ' e ';
        };
        fill += item + ext;
      });
      return fill;
    },
    maxSizeByte: (100 * 1024 * 1024),
    maxSize: '100MB',
    upload: (data) => postFotosReuniao(data),
    getData: (id) => getFotosReuniao(id),
    delete: (idDocumento) => excluir(idDocumento),
  },
  1: {
    label: 'Videos',
    files: [],
    fileExtension: ['mp4', 'WMV', 'MKV', 'AVI'],
    maxSizeByte: (3 * 1024 * 1024 * 1024),
    maxSize: '3GB',
    text: () => {
      let fill = '';
      let arrExt = ['MP4', 'WMV', 'MKV', 'AVI'];
      arrExt.forEach((item, index) => {
        let ext = '';
        if (index < arrExt.length - 2) {
          ext = ', ';
        } else if (index === arrExt.length - 2) {
          ext = ' e ';
        };
        fill += item + ext;
      });
      return fill;
    },
    upload: (data) => postVideosReuniao(data),
    getData: (id) => getVideosReuniao(id),
    delete: (idDocumento) => excluir(idDocumento),
  },
  2: {
    label: 'Áudios',
    files: [],
    fileExtension: ['mp3', 'WMA'],
    maxSize: '100MB',
    maxSizeByte: (100 * 1024 * 1024),
    text: () => {
      let fill = '';
      let arrExt = ['MP3', 'WMA'];
      arrExt.forEach((item, index) => {
        let ext = '';
        if (index < arrExt.length - 2) {
          ext = ', ';
        } else if (index === arrExt.length - 2) {
          ext = ' e ';
        };
        fill += item + ext;
      });
      return fill;
    },
    upload: (data) => postAudiosReuniao(data),
    getData: (id) => getAudiosReuniao(id),
    delete: (idDocumento) => excluir(idDocumento),
  }
}
